import React from 'react';
import { IconProps } from '../IconProps';
const SvgUmbrella = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M17.333 1.845v-.512a1.334 1.334 0 00-2.667 0v.512C7.448 2.521 1.777 8.608 1.777 16a1.335 1.335 0 002.416.78c.12-.167 1.23-1.63 3.168-1.669h.08c2.022 0 3.208 1.604 3.257 1.671.256.352.628.52 1.099.551a1.325 1.325 0 001.08-.581c.047-.068 1.146-1.64 3.123-1.64 1.977 0 3.073 1.572 3.121 1.64.246.36.648.576 1.081.581.4-.032.843-.199 1.099-.55.052-.07 1.289-1.71 3.337-1.672 1.938.04 3.049 1.502 3.168 1.67A1.334 1.334 0 0030.22 16c0-7.392-5.671-13.48-12.889-14.155h.002zm-10.029 10.6a6.448 6.448 0 00-2.462.538 11.595 11.595 0 017.446-7.918c-.964 2.147-1.538 5.113-1.75 8.194-.855-.471-1.916-.847-3.234-.815zm17.389 0c-1.296-.013-2.368.357-3.234.824-.21-3.084-.784-6.055-1.75-8.206a11.602 11.602 0 017.446 7.918 6.449 6.449 0 00-2.462-.537z"
      fill={primaryColor}
    />
    <path
      d="M16 17.334c-.736 0-1.334.597-1.334 1.333v7.334c0 .857-.698 1.555-1.555 1.555a1.558 1.558 0 01-1.556-1.555 1.334 1.334 0 00-2.666 0 4.226 4.226 0 004.222 4.222A4.226 4.226 0 0017.333 26v-7.334c0-.736-.597-1.333-1.333-1.333z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgUmbrella;
